export default function makeShouldScrollToIndex(store) {
  return {
    shouldScrollToIndex: function shouldScrollToIndex(editor, tableId, index) {
      var scrolls = store.getItem('scroll') || {};
      return scrolls.tableId === index;
    }
  };
}